class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      if (cartLink.classList.contains("open")) {
        this.close();
      } else {
        this.open(cartLink);
      }
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        if (cartLink.classList.contains("open")) {
          this.close();
        } else {
          this.open(cartLink);
        }
      }
    });
  }

  open(triggeredBy) {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.classList.add("open");
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    /*this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );*/
    const drawerInner = document.querySelector("#CartDrawer .drawer__inner");
    if (drawerInner) drawerInner.scrollTop = 0;
    document.body.classList.add("overflow-hidden");
  }

  close() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.classList.remove("open");
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");

    // Only update section-header if it exists (not on CRO/LP pages)
    const sectionHeader = document.querySelector(".section-header");
    if (sectionHeader) {
      sectionHeader.classList.remove("cart-open");
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    // Detect if we're on CRO or LP layout
    const isCroPage =
      document.body.classList.contains("cro-page") ||
      document.body.classList.contains("template-lp-product");

    this.getSectionsToRender(isCroPage).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    $("#cart-icon-bubble-mobile").html($("#cart-icon-bubble").html());

    // Update cart count manually on CRO/LP pages since we skip cart-icon-bubble section
    if (isCroPage) {
      console.log("CRO/LP page detected, parsedState:", parsedState);

      // Fetch current cart to get item count
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          console.log("Current cart:", cart);
          const cartCountSpan = document.querySelector(
            '.cart-count-bubble span[aria-hidden="true"]'
          );
          const visuallyHiddenSpan = document.querySelector(
            ".cart-count-bubble .visually-hidden"
          );
          const cartBubble = document.querySelector(".cart-count-bubble");

          if (cartCountSpan) {
            cartCountSpan.textContent = cart.item_count;
            console.log("Updated cart count to:", cart.item_count);
          }

          if (visuallyHiddenSpan) {
            const itemText = cart.item_count === 1 ? "item" : "items";
            visuallyHiddenSpan.textContent = `${cart.item_count} ${itemText}`;
          }

          if (cartBubble) {
            if (cart.item_count > 0) {
              cartBubble.style.display = "flex";
              cartBubble.classList.remove("visually-hidden");
            } else {
              cartBubble.style.display = "none";
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching cart:", error);
        });
    }

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      const cartLink = document.querySelector("#cart-icon-bubble");
      cartLink.classList.add("open");

      // Only update section-header if it exists (not on CRO/LP pages)
      const sectionHeader = document.querySelector(".section-header");
      if (sectionHeader) {
        sectionHeader.classList.add("cart-open");
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender(skipCartIcon = false) {
    const sections = [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];

    // Only include cart-icon-bubble if not on CRO/LP page
    if (!skipCartIcon) {
      sections.push({
        id: "cart-icon-bubble",
      });
    }

    return sections;
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender(skipCartIcon = false) {
    const sections = [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
    ];

    // Only include cart-icon-bubble if not on CRO or LP page
    if (!skipCartIcon) {
      sections.push({
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      });
    }

    return sections;
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
